import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiService} from '../api';

export interface MvelEvalResult {
  results: Map<string, any>;
  errors: Map<string, string>;
}

@Injectable()
export class MvelService {

  constructor(private api: ApiService) {
  }

  public eval(contractId: number, mvelExpressions: Array<string>): Observable<MvelEvalResult> {
    return this.api.ga.silent.post(`/contract/${contractId}/mveleval`, mvelExpressions);
  }
}
